import colors from "../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const TermsOfUseStyle = makeStyles((theme) => ({
	dialogPaper: {
		backgroundColor: colors.paleGray,
		borderRadius: 12,
		boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
		border: `1px solid ${colors.lightGrayBorder}`,
	},
	title: {
		color: colors.white,
		backgroundColor: colors.primary,
		fontWeight: 600,
		fontSize: "1.5rem",
		textAlign: "center",
		padding: theme.spacing(2, 0),
	},
	sectionTitle: {
		color: colors.primary,
		fontWeight: 600,
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(1),
	},
	paragraph: {
		color: colors.charcoalGray,
		fontSize: "0.95rem",
		lineHeight: 1.7,
		marginBottom: theme.spacing(1.5),
	},
	link: {
		color: colors.primary,
		textDecoration: "none",
		fontWeight: 500,
	},
	closeButton: {
		color: colors.white,
		background: `${colors.primary} !important`,
		textTransform: "none",
		width: "120px !important",
		padding: theme.spacing(1, 4),
		"&:hover": {
			backgroundColor: `${colors.darkCrimsonRed} !important`,
		},
	},
	list: {
		color: colors.charcoalGray,
		lineHeight: 1.6,
		marginTop: 0,
		marginBottom: theme.spacing(2),
		paddingLeft: theme.spacing(3),
	},
	dialogAction: {
		justifyContent: "center",
		padding: "16px",
	},
	activationDateText: {
		fontStyle: "italic",
		marginBottom: 16,
	},
	privacyCometment: {
		margin: "24px 0",
		backgroundColor: colors.charcoalGray,
	},
	container: {
		textAlign: "justify",
	},
}));

export default TermsOfUseStyle;
